import { render, staticRenderFns } from "./AdGroup.vue?vue&type=template&id=4ed87f37"
import script from "./AdGroup.vue?vue&type=script&lang=js"
export * from "./AdGroup.vue?vue&type=script&lang=js"
import style0 from "./AdGroup.vue?vue&type=style&index=0&id=4ed87f37&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports